import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PathToLiveWorkflowComponent } from './path-to-live-workflow.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [
    PathToLiveWorkflowComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
    SidenavHeaderModule,
    ErrorModule,

    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatTooltipModule

  ],
  exports: [
    PathToLiveWorkflowComponent
  ]
})
export class PathToLiveWorkflowModule { }
